export default __webpack_public_path__ + "flutter-android@2x.png";